import React from 'react';
import { CalendarView, GlobalCalendarEvent } from '../../types/calendar';
import MonthView from './MonthView';
import WeekView from './WeekView';
import DayView from './DayView';

interface CalendarGridProps {
  view: CalendarView;
  date: Date;
  events: GlobalCalendarEvent[];
  isLoading?: boolean;
  onEventClick: (event: GlobalCalendarEvent) => void;
  onDateClick?: (date: Date) => void;
}

const CalendarGrid: React.FC<CalendarGridProps> = ({
  view,
  date,
  events,
  isLoading,
  onEventClick,
  onDateClick,
}) => {
  if (view === 'month') {
    return (
      <MonthView
        date={date}
        events={events}
        onEventClick={onEventClick}
        onDateClick={onDateClick}
        isLoading={isLoading}
      />
    );
  } else if (view === 'week') {
    return (
      <WeekView
        date={date}
        events={events}
        onEventClick={onEventClick}
        onDateClick={onDateClick}
        isLoading={isLoading}
      />
    );
  } else {
    return (
      <DayView
        date={date}
        events={events}
        onEventClick={onEventClick}
        onDateClick={onDateClick}
        isLoading={isLoading}
      />
    );
  }
};

export default CalendarGrid;
